export const COLORS = {
  ink: 0x06110f,
  panel: 0x0d3b33,
  panelDeep: 0x092a25,
  gold: 0xe8b64c,
  goldDim: 0x8a6b2c,
  cream: 0xf4ead6,
  jade: 0x1f7a68,
  win: 0x62e2b0,
  loss: 0x8aa3a0,
  danger: 0xe06767,
} as const;
